<template>
  <img :src="missingImg" :alt="alt" />
</template>

<script>
  export default {
    name: "base-missing-image",
    props:{
      alt:{
        type: String,
        required: true,
      },
    },
    computed:{
      missingImg(){
        return window.noImageProvidedUrl
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/base/_base-missing-image.vue